import { FormattedMessage } from 'react-intl';
import { Schema } from 'src/utils/form';

export default Schema.object({
  codigo: Schema.string(),
  risco: Schema.string(),
  areas: Schema.string(),
  areasSubordinadas: Schema.boolean(),
  processos: Schema.string(),
  tipoFiltroData: Schema.string().label(
    <FormattedMessage id="label.tipoFiltroData" />
  ),
  dataInicio: Schema.string().label(<FormattedMessage id="dataInicio" />),
  dataTermino: Schema.string().label(<FormattedMessage id="dataTermino" />),
  incluirSubprocessos: Schema.string(),
});
